import { loadAndTrack } from "redux-request-loading";

import { AnsweredQuestionWithId } from "@teamprevent/common/model";
import { SUBMIT_QUESTIONNAIRE, submitQuestionnaireSuccess, saveQuestionnaireSuccess } from "@teamprevent/common/questionnaires/actions";

import { Dispatch } from "../../store";
import { questionnaireKey } from "../../clinicalNotes/components/ClinicalNotes";
import { submitClinicalNotesSuccess } from "../../clinicalNotes/actions";
import { CreateTaskModel } from "../../task/model";

import { clinicalNotesApi } from "./clinicalNotesApi";

export const saveGenericCaseClinicalNotes = (customerId: string, ohCaseId: string, taskId: string, questions: AnsweredQuestionWithId[], eTag: string | null) =>
    async (dispatch: Dispatch) => {
        const response = await loadAndTrack(
            dispatch,
            "SaveGenericCaseClinicalNotes",
            clinicalNotesApi.saveClinicalNotes(customerId, ohCaseId, taskId, questions, eTag));
        dispatch(saveQuestionnaireSuccess({ questionnaireKey, eTag: response.eTag }));
    };

export const submitGenericCaseClinicalNotes = (customerId: string, ohCaseId: string, taskId: string, createTasks: CreateTaskModel[]) =>
    async (dispatch: Dispatch) => {
        const result = await loadAndTrack(dispatch, SUBMIT_QUESTIONNAIRE, clinicalNotesApi.submitClinicalNotes(customerId, ohCaseId, taskId, createTasks));
        dispatch(submitQuestionnaireSuccess(questionnaireKey));
        dispatch(submitClinicalNotesSuccess({
            ohCaseId,
            tasks: result
        }));
    };
